import React, { Component } from 'react';
import _ from 'lodash';

import Form from "react-jsonschema-form";

import { Button } from 'semantic-ui-react';

import ErrorListTemplate from './error-list-template';
import FieldTemplate from './field-template';
import Registry from './registry';

export default class SemanticForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: []
    };
  }

  render() {
    const {
      onError,
      children,
      fields,
      widgets,
      ...formProps
    } = this.props;
    const { errors } = this.state;

    return (
      <Form
        {...formProps}
        className={`ui form ${errors.length ? 'error' : ''}`}
        ErrorList={ErrorListTemplate}
        FieldTemplate={FieldTemplate}
        fields={_.assign({}, Registry.fields, fields)}
        widgets={_.assign({}, Registry.widgets, widgets)}
        onError={(errors) => {
          this.setState({
            errors
          });
          onError(errors);
        }}>
        {
          children
          ? children
          : <Button primary>Submit</Button>
        }
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/index.js